import apiFetch from '../apiFetch'

export default function (token, documentTypeId, dossierIds) {
  return apiFetch({ endPoint: `Document/CheckDocumentInFleet?documentTypeId=${documentTypeId}&dossierIds=${dossierIds}`, method: 'GET', token: token })
}
